<template>
  <figure class="msg tripla action">
    <p>
      <span class="chat-message" v-html="formatChatMessage"></span>
      <label class="input-inside-chat-label">
        <input
          v-model="emailAddress"
          type="email"
          placeholder="email@example.com"
          class="input-inside-chat"
          :class="[{ error: $v.emailAddress.$error }]"
          :disabled="!active"
        />
      </label>

      <label class="input-inside-chat-label">
        <textarea
          v-model="note"
          rows="3"
          class="textarea-inside-chat"
          :placeholder="$t('email_form.note_placeholder')"
          :disabled="!active"
          :class="[{ error: $v.note.$error }]"
        />
      </label>
    </p>
    <ul class="cursor-pointer">
      <li
        v-for="(action, index) in chat.message_rich.actions"
        :class="checkActionState(index)"
        @click="clickAction(emailAddress)"
      >
        {{ action.text }}
      </li>
    </ul>
  </figure>
</template>

<script>
import { Chat } from 'src/apis'
import ActionWidget from './ActionWidget.vue'
import { required, email, maxLength } from 'vuelidate/lib/validators'

export default {
  extends: ActionWidget,
  data() {
    return {
      emailAddress: this.chat.message_rich.email || '',
      note: this.chat.message_rich.note || ''
    }
  },

  methods: {
    clickAction(email) {
      this.$v.$touch()
      if (this.$v.$invalid) return

      if (this.active) {
        Chat.sendForm(
          this.chat.id,
          email,
          this.chat.message_rich.auto_message_info.auto_message_id,
          this.note
        )
          .then(() => {
            this.active = false
          })
          .catch((err) => {
            console.error('fail on sending email', err)
          })
      }
    }
  },

  validations: {
    emailAddress: {
      required,
      maxLength: maxLength(256),
      email
    },
    note: {
      required
    }
  }
}
</script>
